import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MdMenuOpen, MdOutlineMenu } from 'react-icons/md';
import { CiLight } from 'react-icons/ci';
import { FaWallet, FaBell, FaMoon } from 'react-icons/fa';
import { CgSearch } from "react-icons/cg";
import { useMyContext } from '../../../context/MyContext';
import { toast } from 'react-hot-toast'
// import { GiExitDoor } from "react-icons/gi";
import { useAuth } from '../../../routes/Auth';
import {
  Base_Url,
  userdata,
  Url_For_View_Document,
  readnotification,
  payment,
  notification,
  grandTotalAmount
} from '../../../config/config';

const NavBar = () => {
  const { setIsToggleSidebar,
    isToggleSidebar,
    isDarkMode,
    toggleTheme,
    isB2BMode,
    setorderId,
    setIsDarkMode,
    toggleB2BMode,
    selectedCft,
    setSelectedCft
  } = useMyContext();
  const navigate = useNavigate();
  const notificationMenuRef = useRef(null);
  const [walletMenuVisible, setWalletMenuVisible] = useState(false);
  const walletMenuRef = useRef(null);
  const userMenuRef = useRef(null);
  const [userData, setUserData] = useState([]);
  const [userName, setUserName] = useState("");
  const [userMenu, setUserMenu] = useState(false);
  const { logout } = useAuth()
  const user = JSON.parse(localStorage.getItem('user'));
  const [orderIdInput, setOrderIdInput] = useState('');
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');
  const [profile, setProfile] = useState()
  const [notificationMenuVisible, setNotificationMenuVisible] = useState(false);
  const [currentBalanace, setCurrentBalanace] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  // const [isB2B, setIsB2B] = useState(true);
  const [totalAmount, setTotalAmount] = useState(0);
  const profile_flag = localStorage.getItem('profile_flag');
  // const isTestingEnvironment = true;

  // CFT change feedback state
  const [cftChanged, setCftChanged] = useState(false);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser && storedUser.userData.name) {
      setUserName(storedUser.userData.name);
    }
    if (role === "admin") {
      getTotalAmount();
    }
    getPayment();
  }, []);

  useEffect(() => {
    fetchUserData();
    fetchNotifications();
  }, [cus_id, token]);

  const fetchNotifications = async () => {
    const url = Base_Url + notification;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json',
        },
      });
      const result = await response.json();

      if (result.status === "SUCCESS") {
        setNotifications(result.data);
        const unread = result.data.filter(notif => notif.is_read === "0").length;
        setUnreadCount(unread);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const fetchUserData = async () => {
    const url = Base_Url + userdata;
    if (cus_id) {
      try {
        const response = await fetch(url + "/" + cus_id, {
          method: 'GET',
          headers: {
            'token': token,
            'cus_id': cus_id,
            'Content-Type': 'application/json',
          },
        });
        const result = await response.json();
        setUserData(result.data);
        const profile = result.data.profile_image
          ? Url_For_View_Document + result.data.profile_image
          : null;
        setProfile(profile);
        if (result.data.name) {
          setUserName(result.data.name);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }
  };

  const toggleWalletMenu = () => {
    const walletStatus = user.userData.wallet_status;

    if (walletStatus === "1") {
      setWalletMenuVisible(!walletMenuVisible);
    }
  };

  const toggleNotificationMenu = () => {
    setNotificationMenuVisible(!notificationMenuVisible);
  };

  const toggleUserMenu = () => {
    setUserMenu(!userMenu);
  }

  const goToTopUp = () => {
    navigate('/b2b/payments/wallet_recharge');
  };

  const navigation = () => {
    if (profile_flag === "1") {
      navigate('/b2b/profile');
    }
  }

  // const handleLogout = () => {
  //   localStorage.removeItem("user");
  //   document.documentElement.classList.remove('dark');
  //   setIsDarkMode(false);
  //   navigate('/login')
  //   logout()
  //   localStorage.removeItem('cus_id')
  //   localStorage.removeItem('token')
  //   localStorage.removeItem("wallet_status");
  //   localStorage.removeItem("profile_flag");
  //   localStorage.removeItem("role");
  //   localStorage.removeItem("isB2BMode");
  // }


  const handleLogout = () => {
    // Turn OFF B2B mode on logout
    toggleB2BMode(false);
    localStorage.setItem("isB2BMode", false);

    // Clear all storage
    localStorage.removeItem("user");
    document.documentElement.classList.remove('dark');
    setIsDarkMode(false);
    navigate('/login')
    logout()
    localStorage.removeItem('cus_id')
    localStorage.removeItem('token')
    localStorage.removeItem("wallet_status");
    localStorage.removeItem("profile_flag");
    localStorage.removeItem("role");

    // Optional: ensure switch UI resets
    window.location.reload();
  }


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (walletMenuRef.current && !walletMenuRef.current.contains(event.target)) {
        setWalletMenuVisible(false);
      }
      else if (notificationMenuRef.current && !notificationMenuRef.current.contains(event.target)) {
        setNotificationMenuVisible(false);
        handleDeleteNotification();
        fetchNotifications();
      }
      else if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [walletMenuRef, userMenuRef, notificationMenuRef, setWalletMenuVisible, setNotificationMenuVisible, setUserMenu]);

  const handleSearchKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (orderIdInput.trim()) {
        setorderId(orderIdInput);
        navigate('/b2b/shipment/track');
      } else {
      }
    }
  };


  const handleDeleteNotification = async () => {
    const urldelete = Base_Url + readnotification;

    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(urldelete, {
        method: "GET",
        headers: {
          "token": token,
          "cus_id": cusid,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.status === "SUCCESS") {
      } else {
      }
    } catch (error) {
    }
  };

  //   const cftLabels = {
  //   6: "Lite (6 CFT)",
  //   10: "Heavy (10 CFT)",
  //   15: "Dense (15 CFT)",
  // }

  const getPayment = async () => {
    const url = Base_Url + payment
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        setCurrentBalanace(data.totalamount);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const getTotalAmount = async () => {
    const uri = Base_Url + "admin/" + grandTotalAmount;

    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(uri, {
        method: "GET",
        headers: {
          "token": token,
          "cus_id": cusid,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.status === "SUCCESS") {
        // setTotalAmount(parseFloat(data.grand_total).toFixed(2)); 
        setTotalAmount(data.grand_total);
      } else {
        console.error("Error:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  // const switchToB2C = () => {
  //   navigate("/dashboard");
  //   window.location.reload();
  // }

  const switchToB2C = () => {
    // Toggle B2B mode in the context
    toggleB2BMode(!isB2BMode);

    // Navigate to the appropriate dashboard
    if (!isB2BMode) {
      navigate("/b2b/dashboard");
      window.location.reload();
    } else {
      navigate("/dashboard");
      window.location.reload();
    }
  };

  // CFT dropdown change handler with visual feedback (whole-page effect)
  const cftLabelMap = { 6: "Lite (6 CFT)", 10: "Heavy (10 CFT)", 15: "Dense (15 CFT)" };

  const handleCftChange = (e) => {
    const newVal = Number(e.target.value);
    setSelectedCft(newVal);
    setCftChanged(true);

    // Page-wide toast notification (shows over entire page, not just navbar)
    toast.success(`Switched to ${cftLabelMap[newVal]}`, {
      duration: 1800,
      style: {
        borderRadius: '10px',
        background: '#10B981',
        color: '#fff',
        fontWeight: 600,
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#10B981',
      },
    });

    setTimeout(() => setCftChanged(false), 700);
  };


  const SwitchIcon = ({ isOn, onToggle }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="24"
        viewBox="0 0 40 22"
        onClick={onToggle}  // 🔥 call switchToB2B when clicked
        className="cursor-pointer transition-colors duration-300"
      >
        {/* Background Bar */}
        <rect
          x="1"
          y="1"
          rx="11"
          ry="11"
          width="38"
          height="20"
          className={`transition-colors duration-300 ${isOn ? "fill-blue-500" : "fill-gray-400"
            }`}
        />

        {/* B2C Text - only show when switch is off */}
        {!isOn && (
          <text
            x="29"
            y="12"
            textAnchor="middle"
            dominantBaseline="middle"
            className="fill-white text-xs font-medium pointer-events-none select-none"
            style={{ fontSize: '7px' }}
          >
            B2C
          </text>
        )}

        {/* B2B Text - only show when switch is on */}
        {isOn && (
          <text
            x="11"
            y="12"
            textAnchor="middle"
            dominantBaseline="middle"
            className="fill-white text-xs font-medium pointer-events-none select-none"
            style={{ fontSize: '7px' }}
          >
            B2B
          </text>
        )}

        {/* Circle Knob */}
        <circle
          cx={isOn ? "29" : "11"}
          cy="11"
          r="8"
          className="fill-white transition-all duration-300"
        />
      </svg>
    );
  };
  const NotificationMenu = () => (
    <div
      ref={notificationMenuRef}
      className="absolute right-0 mt-4 w-80 bg-white dark:bg-[#071a74f6] border border-gray-200 rounded-lg shadow-lg z-50 max-h-96 overflow-y-auto"
    >
      <div className="p-4 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-lg font-semibold dark:text-white">Notifications</h3>
      </div>
      {notifications.length === 0 ? (
        <div className="p-4 text-center text-gray-500 dark:text-gray-400">
          No notifications
        </div>
      ) : (
        <ul className="divide-y divide-gray-200 dark:divide-gray-700">
          {notifications.map((notification) => (
            <li
              key={notification.id}
              className={`p-4 hover:bg-gray-50 dark:hover:bg-purple-700 transition-colors duration-200 cursor-pointer ${notification.is_read === "0" ? 'bg-blue-50 dark:bg-blue-900/20' : ''
                }`}
            // onClick={() => markAsRead(notification.id)}
            >
              <div className="flex flex-col">
                <span className="font-semibold text-sm dark:text-white">
                  {notification.title}
                </span>
                <span className="text-sm text-gray-600 dark:text-gray-300">
                  {notification.message}
                </span>
                <span className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  {new Date(notification.created_at).toLocaleString()}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  return (
    <>
      {/* GLOBAL PAGE-WIDE EFFECT: center loader overlay, covers entire viewport */}
      <div
        className={`fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none transition-all duration-300 ${
          cftChanged ? "opacity-100" : "opacity-0"
        }`}
      >
        {/* Soft backdrop */}
        <div className="absolute inset-0 bg-black/10 backdrop-blur-[2px]"></div>

        {/* Center loader card */}
        <div
          className={`relative bg-white dark:bg-gray-900 rounded-2xl shadow-2xl px-8 py-6 flex flex-col items-center gap-3 transition-all duration-300 ${
            cftChanged ? "scale-100 opacity-100" : "scale-75 opacity-0"
          }`}
        >
          <div className="w-10 h-10 border-4 border-green-200 border-t-green-500 rounded-full animate-spin"></div>
          <span className="text-sm font-semibold text-gray-700 dark:text-gray-200 whitespace-nowrap">
            {cftLabelMap[selectedCft]}
          </span>
        </div>
      </div>

    <div className="flex  items-center justify-between px-4 py-2  md:py-0 relative  bg-transparent" style={{ backgroundColor: '#fff' }}>
      <div className="flex items-center">

        <Link to="/b2b/dashboard">
          <div className="flex items-center cursor-pointer pl-0 md:pl-0">
            <img src="/assets/images/logo1.png" alt="Logo" className="w-[60px] h-[40px] sm:w-[120px] sm:h-[50px] lg:w-[190px] lg:h-[100px]" />
          </div>
        </Link>
        <button
          onClick={() => setIsToggleSidebar(!isToggleSidebar)}
          className="ml-7 md:ml-10 text-blue-500 dark:text-white"
        >
          {isToggleSidebar === false ? <MdMenuOpen size={28} /> : <MdOutlineMenu size={28} />}
        </button>
      </div>
      <div className="flex-grow ml-16   order-3 md:order-2 w-full md:w-auto mt-4 md:mt-0">
        <div className="relative flex items-center bg-gray-100 dark:bg-[#071a74f6] rounded-md w-full md:w-[75%]">
          <CgSearch className={`absolute left-3 ${isDarkMode ? "dark:text-white" : "text-custom-gray"}`} size={24} />
          <input
            type="text"
            value={orderIdInput}
            onChange={(e) => setOrderIdInput(e.target.value)}
            onKeyDown={handleSearchKeyDown}
            placeholder="Search with Order ID"
            className={`font-sans bg-gray-200 dark:bg-[#071a74f6] w-full h-[40px] border-0 outline-none rounded-[10px] pl-[50px] pr-[10px] bg-opacity-70 text-[12px] md:text-[22px] ${isDarkMode ? "placeholder-white" : "placeholder-custom"} font-san dark:text-white`}
          />

        </div>
      </div>
      <div className="flex items-center space-x-3 md:space-x-4  pr-0 order-2 md:order-3 relative">
        {/* CFT Selector with Modern Design */}
        <span className="flex items-center gap-2">
          <div className="relative group">
            <select
              value={selectedCft}
              onChange={handleCftChange}
              className={`w-[95px] pl-4 pr-10 py-1 rounded-xl  mr-3
        bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-900
        text-gray-900 dark:text-white
        text-sm font-semibold
        border-2 dark:border-gray-700
        shadow-md
        focus:outline-none
        focus:ring-blue-500
        focus:border-blue-400
        cursor-pointer
        transition-all duration-300
        hover:shadow-lg hover:scale-[1.02]
        appearance-none
        text-xs
        ${cftChanged ? "border-green-500 ring-2 ring-green-400 scale-105" : "border-blue-200"}`}
            >
              <option value={6}>Lite</option>
              <option value={10}>Heavy</option>
              <option value={15}>Dense</option>
            </select>

            {/* Green dot INSIDE dropdown - pings on change */}
            <div className="absolute right-8 top-1/2 -translate-y-1/2">
              <div
                className={`rounded-full bg-green-500 transition-all duration-300 ${
                  cftChanged ? "w-3 h-3 animate-ping" : "w-2 h-2 animate-pulse"
                }`}
              ></div>
            </div>

            {/* "Updated" floating badge - shows only on change */}
            {cftChanged && (
              <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-[10px] font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-full shadow-sm animate-bounce whitespace-nowrap">
                Updated ✓
              </span>
            )}

            {/* Custom Dropdown Arrow */}
            {/* <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
              <svg
                className="w-4 h-4 text-blue-600 dark:text-blue-400 group-hover:rotate-180 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div> */}
          </div>
        </span>


        {/* B2B/B2C Toggle */}
        <div className="relative group">
          <div className="relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="32"
              viewBox="0 0 60 32"
              onClick={switchToB2C}
              className="cursor-pointer transition-all duration-300 hover:scale-105 filter hover:drop-shadow-lg"
            >
              {/* Background Bar with Gradient */}
              <defs>
                <linearGradient id="onGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{ stopColor: '#3B82F6', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#1D4ED8', stopOpacity: 1 }} />
                </linearGradient>
                <linearGradient id="offGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{ stopColor: '#9CA3AF', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#6B7280', stopOpacity: 1 }} />
                </linearGradient>
              </defs>

              <rect
                x="2"
                y="2"
                rx="14"
                ry="14"
                width="54"
                height="27"
                fill={isB2BMode ? "url(#onGradient)" : "url(#offGradient)"}
                className="transition-all duration-300"
              />

              {/* B2C Text - show when OFF */}
              {!isB2BMode && (
                <text
                  x="42"
                  y="17"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="fill-white font-bold pointer-events-none select-none"
                  style={{ fontSize: '10px', fontFamily: 'system-ui' }}
                >
                  B2C
                </text>
              )}

              {/* B2B Text - show when ON */}
              {isB2BMode && (
                <text
                  x="18"
                  y="17"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="fill-white font-bold pointer-events-none select-none"
                  style={{ fontSize: '10px', fontFamily: 'system-ui' }}
                >
                  B2B
                </text>
              )}

              {/* Circle Knob with Shadow */}
              <circle
                cx={isB2BMode ? "44" : "16"}
                cy="16"
                r="11"
                className="fill-white transition-all duration-300 filter drop-shadow-md"
              />

              {/* Inner circle for depth */}
              <circle
                cx={isB2BMode ? "44" : "16"}
                cy="16"
                r="8"
                className="fill-white transition-all duration-300"
              />
            </svg>
          </div>
        </div>

        {/* Theme Toggle Button */}
        <div className="relative group">
          <button
            onClick={toggleTheme}
            className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105"
          >
            {isDarkMode ?
              <CiLight size={26} className="text-white transition-colors duration-300" /> :
              <FaMoon size={26} className="text-blue-500 transition-colors duration-300" />
            }
          </button>
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
            {isDarkMode ? "Light Mode" : "Dark Mode"}
          </span>
        </div>

        {/* Wallet Button */}
        <div className="relative group">
          <button
            onClick={toggleWalletMenu}
            className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105 focus:outline-none"
            aria-label="Toggle wallet menu"
          >
            <FaWallet size={26} className={`transition-colors duration-300 ${isDarkMode ? "text-white" : "text-blue-500"}`} />
          </button>

          {/* Wallet Menu */}
          {walletMenuVisible && (
            <div
              ref={walletMenuRef}
              className="absolute right-0 mt-4 w-56 bg-white dark:bg-[#071a74f6] border border-gray-200 rounded-lg shadow-lg z-50 transition-all duration-200 ease-in-out overflow-hidden"
            >
              <ul className="text-gray-700 dark:text-gray-200 dark:shadow-custom-dark divide-y divide-gray-200 dark:divide-gray-700">
                <li className="py-2 px-4 cursor-default flex items-center justify-between">
                  <span>Balance</span>
                  {role !== "admin" ? (
                    <span className="font-semibold">₹ {currentBalanace}</span>
                  ) : (
                    <span className="font-semibold">₹ {totalAmount}</span>
                  )}
                </li>
                <li
                  className="py-2 px-4 cursor-pointer hover:bg-gray-100 hover:dark:bg-purple-700 transition-colors duration-200 flex items-center justify-between"
                  onClick={goToTopUp}
                >
                  <span>Top-Up</span>
                  <span className="text-gray-400">|</span>
                </li>
              </ul>
            </div>
          )}

          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
            Wallet
          </span>
        </div>

        {/* Notification Button */}
        <div className="relative group">
          <button
            onClick={toggleNotificationMenu}
            className="w-11 h-11 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105 focus:outline-none"
            aria-label="Toggle notification menu"
          >
            <FaBell
              size={26}
              className={`transition-all duration-300 ${isDarkMode ? "text-white" : "text-blue-500"}`}
            />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center animate-pulse">
                {unreadCount}
              </span>
            )}
          </button>

          {notificationMenuVisible && <NotificationMenu />}

          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-xs bg-gray-800 text-white dark:bg-white dark:text-black px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50">
            Notifications
          </span>
        </div>

        {/* User Profile Button */}
        <div className="relative group">
          <button
            onClick={toggleUserMenu}
            className="text-white hidden lg:flex rounded-full dark:text-white items-center relative transition-all duration-300 hover:scale-105"
          >
            <div className="flex items-center space-x-3">
              <div className="relative">
                {profile ? (
                  <img
                    src={profile}
                    alt="Profile picture"
                    className={`w-9 h-9 rounded-full border-2 shadow-lg transition-all duration-300 ${isDarkMode ? "border-white" : "border-gray-900"
                      }`}
                  />
                ) : (
                  <div
                    className={`w-8 h-8 rounded-full border-2 shadow-lg flex items-center justify-center text-white font-bold text-sm transition-all duration-300 ${isDarkMode ? "bg-red-500 border-white" : "bg-red-500 border-gray-900"
                      }`}
                  >
                    {userName ? userName.slice(0, 2).toUpperCase() : "NA"}
                  </div>
                )}
                <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full animate-pulse"></span>
              </div>
              <span
                className={`text-xl font-semibold transition-colors duration-300 ${isDarkMode ? "text-white glow" : "text-gray-900"
                  }`}
              >
                {userName}
              </span>
            </div>
          </button>

          {/* User Menu */}
          {userMenu && (
            <div
              ref={userMenuRef}
              className="absolute top-full right-0 mt-4 w-32 bg-white dark:bg-[#071a74f6] border border-gray-200 rounded-lg shadow-lg z-50 transition-all duration-200 ease-in-out overflow-hidden"
            >
              <ul className="text-gray-700 dark:text-gray-200 dark:shadow-custom-dark divide-y divide-gray-200 dark:divide-gray-700">
                <li
                  onClick={navigation}
                  className="py-3 px-4 cursor-pointer hover:bg-gray-100 hover:dark:bg-purple-700 transition-colors duration-200"
                >
                  Profile
                </li>
                <li
                  onClick={handleLogout}
                  className="py-3 px-4 cursor-pointer hover:bg-gray-100 hover:dark:bg-purple-700 transition-colors duration-200"
                >
                  Logout
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

    </div>
    </>
  );
};
export default NavBar;